/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { string, bool, func, number } from 'prop-types';

const Options = ({
  price,
  onChange,
  subscribed,
  discount,
  disabled
}) => {

  const handleChange = () => {
    onChange(!subscribed);
  };

  const discountPrice = () => {
    return (((100 - discount) / 100) * price).toFixed(2);
  };

  return disabled
    ? (
      <div className="radio-btn__content-wrapper subscribe-and-save-options__opt-in_disabled">
        <input
          type="radio"
          className="radio-btn__input"
          name="subscribe-and-save-radio"
          id="subscribe-and-save-options__opt-in"
          disabled
          value="subscribe"
        />
        <label className="radio-btn__label" htmlFor="subscribe-and-save-options__opt-in_disabled">
          <span className="radio-btn" />
          <span className="subscribe-and-save-options__title">
            Subscribe and
            <span className="subscribe-and-save-options__title-discount"> Get {discount}% off</span>
          </span>
        </label>
      </div>
    )
    : (
      <form className="subscribe-and-save-options">
        <div className="radio-btn__content-wrapper">
          <input
            type="radio"
            className="radio-btn__input"
            name="subscribe-and-save-radio"
            id="subscribe-and-save-options__opt-out"
            onChange={handleChange}
            checked={!subscribed}
            value="one-time-purchase"
          />
          <label className="radio-btn__label" htmlFor="subscribe-and-save-options__opt-out">
            <span className="radio-btn" />
            <span className="subscribe-and-save-options__opt-out">One-Time Purchase</span>
          </label>
        </div>
        <div className="radio-btn__content-wrapper subscribe-and-save-options__opt-in">
          <input
            type="radio"
            className="radio-btn__input"
            name="subscribe-and-save-radio"
            id="subscribe-and-save-options__opt-in"
            onChange={handleChange}
            checked={subscribed}
            value="subscribe"
          />
          <label className="radio-btn__label" htmlFor="subscribe-and-save-options__opt-in">
            <span className="radio-btn" />
            <span className="subscribe-and-save-options__title">
              ${`${discountPrice()} `}&mdash; Subscribe and
              <span className="subscribe-and-save-options__title-discount"> Get {discount}% off</span>
            </span>
          </label>
        </div>
      </form>
    );
};

Options.displayName = 'SubscribeAndSave-Options';

Options.propTypes = {
  onChange: func.isRequired,
  price: number,
  subscribed: bool,
  discount: string,
  disabled: bool
};

Options.defaultProps = {
  price: null,
  subscribed: false,
  discount: '5',
  disabled: false
};

export { Options };